import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";

interface  ErrorEvent {
  status: number;
  message: string;
  url: string;
  /**
   * Der geparste Response-Body. Der Status allein reicht nicht mehr aus, um eine Meldung zu
   * wählen: die Auth-Endpunkte liefern unter 400/403 mehrere Zustände (nicht verifiziert, zur
   * Löschung vorgemerkt, gelöscht) und unterscheiden sie über {reason, deletionDate}.
   */
  error?: any;
}

/**
 * Service for HTTP Error Handling
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  /**
   * Subject of Error Responses
   * @private
   */
  private errorEvent: Subject<ErrorEvent> = new Subject();

  /**
   * ErrorEvents as Observable
   */
  public errorEvent$ = this.errorEvent.asObservable();

  /**
   * Constructor
   */
  constructor() {
  }

  /**
   * Triggers new error
   * @param error new HTTP Error Response
   */
  public triggerError(error: HttpErrorResponse): void {
    this.errorEvent.next({status: error.status, url: error.url!, message: error.message, error: error.error});
  }
}
